import { render, staticRenderFns } from "./SysMenuList.vue?vue&type=template&id=23b0168f&scoped=true"
import script from "./SysMenuList.vue?vue&type=script&lang=js"
export * from "./SysMenuList.vue?vue&type=script&lang=js"
import style0 from "./SysMenuList.vue?vue&type=style&index=0&id=23b0168f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0168f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b0168f')) {
      api.createRecord('23b0168f', component.options)
    } else {
      api.reload('23b0168f', component.options)
    }
    module.hot.accept("./SysMenuList.vue?vue&type=template&id=23b0168f&scoped=true", function () {
      api.rerender('23b0168f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/adminmanage/SysMenuList.vue"
export default component.exports